export const getWithPrefixPhone = (phone?: string) => {
  if (!phone || phone.length < 4) {
    return null;
  }

  return phone[0] === "+" ? phone : `+${phone}`;
};
